// Module
import React, { useEffect, useState } from 'react';
import { useRoutes, useLocation, Navigate, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

// Common CSS
import '_Asset/css/reset.css'
import '_Asset/css/common.css'
import '_Asset/css/icofont.min.css'

// API
import { CmLoginChkApi, MemLoginChkApi } from './Api';

// Component
import 'Lang/i18n' // 다국어 설정 js 파일
import { Header, Footer, SideMenu } from 'User/Include'; // User Include
import { // USER Page
  Main, Login, Forbidden,
  /*CodeLab, OpenSource,*/
  APIManual, APIManualDt, APIManualSearch, ATM, TestingAPI,
  DevSupport, FAQ,
  DevGuide, UIComponent,
  News, NewsDt, Conference, ConferenceDt, /*Blog, BlogDt,*/
  DvlpEmploy, PvPolicy, TOS
} from 'User/Page';

import { AdHeader, AdSideMenu } from 'Admin/Include' // Admin Include
import { // ADMIN Page
  AdLogin,
  AdConference, AdConferenceDt,
  AdDevGuide, AdDevGuideDt,
  AdDevSupport, AdDevSupportDt,
  AdFAQ, AdFAQDt,
  AdKM, AdKMDt,
  AdNews, AdNewsDt,
  AdDevEmploy, AdDevEmployDt, AdJoin, AdJoinDt,
  AdMem, AdMemDt,
  AdCustomer, AdCustomerDt, AdReviewAprvMgt, AdReviewAprvList, AdReceipt, AdReviewAprvAppt, AdDevSupportSvc, AdDevSupportSvcDt, AdKMSpace, AdKMSpaceDt, AdDashboard
} from 'Admin/Page';
import { setInfoAcc, setInfoCust, setLoggedAcc, setLoggedCust } from 'Modules/authority';


const App = () => {

  // Use Hooks
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation();
  const pathChk = location.pathname.split('/')[1];

  const authHost = process.env.REACT_APP_AUTH_HOST

  const [fixedState, setFixedState] = useState(''); // User

  const isLoginCust = useSelector(state => state.loggedCust) // 고객 로그인 상태
  const isLoginAcc = useSelector(state => state.loggedAcc) // 회원 로그인 상태

  const memSessionID = localStorage.getItem('memSessionID'); // 회원 로그인 Session ID
  const custSessionID = localStorage.getItem('custSessionID'); // 고객 로그인 Session ID
  const checkKey = localStorage.getItem('memLoginKey')

  const [loading, setLoading] = useState(false)
  

  // 라우터 설정
  const routeList = [
    // * User Page
    { path: "/", element: <Main /> },
    (
      isLoginCust ? 
      { path: "/customer-login", element: <Navigate replace to="/" /> }
      :
      { path: "/customer-login", element: <Login /> }
    ), 
    { path: "/connect", element: <Navigate replace to="/connect/news" /> },
    { 
      path: "/connect",
      children: [
        { path: "news", element: <News /> },
        { path: "news/:key", element: <News /> },
        { path: "news/list/:id", element: <NewsDt /> },
        { path: "conference", element: <Conference /> },
        { path: "conference/:key", element: <Conference /> },
        { path: "conference/list/:id", element: <ConferenceDt /> },
        // Blog 임시 주석처리 [2022.07.25]
        // { path: "blog", element: <Blog /> },        
        // { path: "blog/:key", element: <Blog /> },        
        // { path: "blog/list/:id", element: <BlogDt /> },        
      ]
    },
    { path: "/design", element: <Navigate replace to="/design/ui-components" /> },
    {
      path: "/design",
      children: [
        { path: "ui-components", element: <UIComponent /> },
        { path: "development-guide", element: <DevGuide /> },
        { path: "development-guide/:key", element: <DevGuide /> },
      ]
    },
    { path: "/develop", element: <Navigate replace to="/develop/testing-apis" /> },
    {
      path: "/develop",
      children: [
        // { path: "access-token-management", element: <ATM /> },
        { path: "apis-manual", element: <APIManual /> },
        { path: "apis-manual/:key", element: <APIManual /> },
        { path: "apis-manual/:key/:id", element: <APIManualDt /> },
        { path: "apis-manual/search", element: <APIManualSearch /> },
        { path: "apis-manual/search/:key", element: <APIManualSearch /> },
        { path: "testing-apis", element: <TestingAPI />},
      ]
    },   
    // { path: "/learn", element: <Navigate replace to="/learn/code-lab" /> },
    // {
    //   path: "/learn",
    //   children: [
    //     { path: "code-lab", element: <CodeLab /> },
    //     { path: "open-source", element: <OpenSource /> },
    //   ]
    // },
    { path: "/support", element: <Navigate replace to="/support/developer-support" /> },
    {
      path: "/support",
      children: [
        // Forums Page 사라짐에 따라 주석 처리
        // { path: "ask-the-community", element: <AskCommunity /> },
        { path: "developer-support", element: <DevSupport /> },
        { path: "frequently-asked-questions", element: <FAQ />},
        { path: "frequently-asked-questions/:key", element: <FAQ />},
      ]
    },
    { path: "/addition", element: <Navigate replace to="/addition/developer-employ" /> },
    {
      path: "/addition",
      children: [
        // Addition Menu
        { path: "developer-employ", element: <DvlpEmploy /> },
        { path: "developer-employ/:key", element: <DvlpEmploy /> },
        { path: "developer-employ/list/:id", element: <DvlpEmploy /> },
        { path: "privacy-policy", element: <PvPolicy /> },
        { path: "terms-of-service", element: <TOS /> },
      ]
    },
    // * Admin Page
    { path: "/admin", element: <Navigate replace to="/admin/dashboard" /> },
    { path: "/member-login", element: <AdLogin /> },
    (
      isLoginAcc &&
      (
        { path: "/member-login", element: <Navigate replace to="/admin/dashboard" /> },
        {
          path: "/admin",
          children: [
            // Dashboard
            { path: "dashboard", element: <AdDashboard /> },
    
            // Development Guide
            { path: "dev-guide", element: <Navigate replace to="/admin/dev-guide/policy/list" /> },
            { path: "dev-guide/policy/list", element: <AdDevGuide type="policy" /> },
            { path: "dev-guide/policy/list/:key", element: <AdDevGuide type="policy" /> },
            { path: "dev-guide/policy/view/:id", element: <AdDevGuideDt type="policy" /> }, 
            { path: "dev-guide/regulation/list", element: <AdDevGuide type="regulation" /> },
            { path: "dev-guide/regulation/list/:key", element: <AdDevGuide type="regulation" /> },
            { path: "dev-guide/regulation/view/:id", element: <AdDevGuideDt type="regulation" /> }, 
    
            // Development Support
            // * 문의 내역 관리
            { path: "dev-support", element: <Navigate replace to="/admin/dev-support/list" /> },
            { path: "dev-support/list", element: <AdDevSupport /> },
            { path: "dev-support/list/:key", element: <AdDevSupport /> },
            { path: "dev-support/replay-mail", element: <Navigate replace to="/admin/dev-support/list" /> },
            { path: "dev-support/replay-mail/:id", element: <AdDevSupportDt /> },
            // * 서비스 카테고리 관리
            { path: "dev-support/service-list", element: <AdDevSupportSvc /> },
            { path: "dev-support/service-list/:key", element: <AdDevSupportSvc /> },
            { path: "dev-support/service-view/", element: <AdDevSupportSvcDt /> },
            { path: "dev-support/service-view/:id", element: <AdDevSupportSvcDt /> },
    
            // FAQ
            { path: "faq", element: <Navigate replace to="/admin/faq/list" /> },
            { path: "faq/list", element: <AdFAQ /> }, // FAQ 리스트
            { path: "faq/list/:key", element: <AdFAQ /> },
            { path: "faq/view", element: <Navigate replace to="/admin/faq/view/add" />},
            { path: "faq/view/:id", element: <AdFAQDt /> }, // FAQ 리스트 관리
            
            // KM
            { path: "km", element: <Navigate replace to="/admin/km/list" /> },
            { path: "km/list", element: <AdKM /> },
            { path: "km/list/:key", element: <AdKM /> },
            { path: "km/view", element: <Navigate replace to="/admin/km/add" /> },
            { path: "km/view/:id", element: <AdKMDt /> },
            { path: "km/add", element: <AdKMDt /> },
            { path: "km/add/:id", element: <AdKMDt /> },
    
            { path: "km/space-list", element: <AdKMSpace /> },
            { path: "km/space-list/:key", element: <AdKMSpace /> },
            { path: "km/space-view", element: <AdKMSpaceDt /> },
            { path: "km/space-view/:id", element: <AdKMSpaceDt /> },
    
            // News
            { path: "news", element: <Navigate replace to="/admin/news/list" /> },
            { path: "news/list", element: <AdNews /> },
            { path: "news/list/:key", element: <AdNews /> },
            { path: "news/view", element: <Navigate replace to="/admin/news/view/add" /> },
            { path: "news/view/:id", element: <AdNewsDt /> },
    
            // Conference
            { path: "conference", element: <Navigate replace to="/admin/conference/list" /> },
            { path: "conference/list", element: <AdConference /> },
            { path: "conference/list/:key", element: <AdConference /> },
            { path: "conference/view", element: <Navigate replace to="/admin/conference/view/add" /> },
            { path: "conference/view/:id", element: <AdConferenceDt /> },
    
            // Developer Employ (개발자 채용)
            // * 채용 글 관리
            { path: "dev-employ", element: <Navigate replace to="/admin/dev-employ/incruit/list" /> },
            { path: "dev-employ/incruit/list", element: <AdDevEmploy /> },
            { path: "dev-employ/incruit/list/:key", element: <AdDevEmploy /> },
            { path: "dev-employ/incruit/view", element: <Navigate replace to="/admin/dev-employ/view/add" /> },
            { path: "dev-employ/incruit/view/:id", element: <AdDevEmployDt /> },
            // * 지원자 관리
            { path: "dev-employ/join/list", element: <AdJoin /> },
            { path: "dev-employ/join/list/:key", element: <AdJoin /> },
            { path: "dev-employ/join/view", element: <Navigate replace to="/admin/join/view/add" /> },
            { path: "dev-employ/join/view/:id", element: <AdJoinDt /> },
    
            // 검토/승인 관리
            { path: "review-aprv", element: <Navigate replace to="/admin/review-aprv/mgt" /> },
            { path: "review-aprv/mgt", element: <AdReviewAprvMgt /> },
            { path: "review-aprv/mgt/:key", element: <AdReviewAprvMgt /> },
            { path: "review-aprv/receipt", element: <AdReceipt /> },
            { path: "review-aprv/receipt/:key", element: <AdReceipt /> },
            { path: "review-aprv/appt", element: <AdReviewAprvAppt /> },
            { path: "review-aprv/list", element: <AdReviewAprvList /> },
    
            // 회원 관리
            { path: "member-mgt", element: <Navigate replace to="/admin/member-mgt/list" /> },
            { path: "member-mgt/list", element: <AdMem /> },
            { path: "member-mgt/list/:key", element: <AdMem /> },
            { path: "member-mgt/view", element: <Navigate replace to="/admin/member-mgt/view/add" /> },
            { path: "member-mgt/view/:id", element: <AdMemDt /> },
    
            // 고객 관리
            { path: "customer-mgt", element: <Navigate replace to="/admin/customer-mgt/list" /> },
            { path: "customer-mgt/list", element: <AdCustomer /> },
            { path: "customer-mgt/list/:key", element: <AdCustomer /> },
            { path: "customer-mgt/view", element: <Navigate replace to="/admin/customer-mgt/view/add" /> },
            { path: "customer-mgt/view/:id", element: <AdCustomerDt /> },
          ]
        }
      )
    ),

    // 404 Page
    (
      isLoginAcc === false && pathChk === 'admin' ?
      { path: "*", element: <Navigate replace to="/member-login" /> }
      :
      { path: "*", element: <Navigate replace to="/404" /> }
    ),
    { path: "/404", element: <Forbidden /> },
  ];
  let devPortalPage = useRoutes(routeList);


  useEffect(() => {
    const html = document.querySelector('html')
    const body = document.querySelector('body')
    const root = document.querySelector('#root')

    if(pathChk === 'customer-login' || pathChk === 'member-login' || pathChk === '404' || pathChk === 'admin') {
      body.style = 'height: 100%'
      html.style = 'height: 100%'
    } else {
      body.style = 'height: unset'
      html.style = 'height: unset'
    }

    // path id 추가
    body.setAttribute('id', pathChk ?? '')
    
    if(pathChk === 'admin') {
      body.style = 'height: 100%; overflow-y: hidden'
      root.style = 'max-width: unset'
    }
  }, [location])


  /*========================================================================
  * 로그인 상태 체크 및 유저 정보 설정
  ========================================================================*/
  // Seyfert 인증센터 로그아웃
  const seyfertLogout = () => {
    axios.defaults.withCredentials = true;
    axios({
      url: `${authHost}/logout`,
      method: 'POST'
    })
    .then(res => {
      // console.log(res, "Seyfert 인증센터 Logout Success!")
      localStorage.clear()
      dispatch(setLoggedAcc(false))
    })
    .catch(err => {
      console.log(err, "Seyfert 인증센터 Logout Error...")
    })
  }
  
  useEffect(() => {
    if (pathChk === 'admin' || pathChk === 'member-login') { // 회원 로그인 체크
      if (memSessionID !== null) {
        axios({
          url: MemLoginChkApi,
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            'Authorization': memSessionID,
          },
          params: {
            check: checkKey,
          },
        })
        .then(res => {
          //console.log(res, "Member Login Check Success!")
          dispatch(setLoggedAcc(res.data.loggedIn))

          if(res.data.loggedIn) {
            const decodedInfo = JSON.parse(res.data.decoded)
            dispatch(setInfoAcc({ // 로그인된 회원 정보 설정
              dPcompany: decodedInfo.company,
              dPemail: decodedInfo.email,
              dPip: decodedInfo.ip,
              dPis_allow_ip: decodedInfo.is_allow_ip,
              dPis_allow_access_time: decodedInfo.is_allow_access_time,
              dPname: decodedInfo.name,
              dPphone_number: decodedInfo.phone_number,
              dProles: decodedInfo.roles,
              dProles_num: res.data.roles_num,
              dPuid: decodedInfo.uid,
              dPaccess_score: decodedInfo.access_score,
              // dPaccess_score: 300,
              dPmaster: res.data.master,
            }));
          } else {
            seyfertLogout()
            alert('세션이 만료되었습니다. 다시 로그인을 시도해주세요.')
            window.location.href = '/member-login'
          }
        })
        .catch(err => {
          console.error(err, "Mmeber Login Check ERROR...")
          dispatch(setLoggedAcc(false))
        })
        .finally(() => { // 로그인 상태, 회원 정보 저장 완료시 Router 로드
          // console.log("Member Login Request End!");
          setLoading(true);
        })
      } else {
        dispatch(setLoggedAcc(false))
        setLoading(true);
      }
    } else { // 고객 로그인 체크
      if (custSessionID !== null) {
        axios({
          url: CmLoginChkApi,
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            'Authorization': custSessionID,
          },
        })
        .then(res => {
          // console.log(res, 'Customer Login Check Success!')
          dispatch(setLoggedCust(res.data.loggedIn))

          if(res.data.loggedIn) {
            dispatch(setInfoCust({ // 로그인된 회원 정보 설정
              dPcorp: res.data.custCorp,
              dPid: res.data.custId,
              dPname: res.data.custName,
              dPuuid: res.data.custUuid,
              dPchangePass: res.data.custChangePass,
            }));
          } else {
            localStorage.removeItem('custSessionID')
            dispatch(setLoggedCust(false))
            alert('세션이 만료되었습니다. 다시 로그인을 시도해주세요.')
          }
        })
        .catch(err => {
          dispatch(setLoggedCust(false))
          console.error(err, 'Customer Login Check Error...')
        })
        .finally(() => { // 로그인 상태, 회원 정보 저장 완료시 Router 로드
          // console.log("Customer Login Request End!");
          setLoading(true);
        })
      } else {
        dispatch(setLoggedCust(false))
        setLoading(true);
      }
    }
  }, [location]);


  if(loading) {
    return (
      <>
        {pathChk === '404' || pathChk === 'member-login' ? 
          <>
            {devPortalPage}
          </>
          :
          pathChk !== 'admin' ? // User Page
            <> 
              <Header fixedState={fixedState} setFixedState={setFixedState} />
            
              <div className="layoutGrid">
                {                  
                  (location.pathname !== '/' && pathChk !== 'customer-login') &&
                  <SideMenu fixedState={fixedState} setFixedState={setFixedState} />
                }
                <div className={`layoutContents ${pathChk === 'customer-login' ? 'cmLogin' : ''}`}>
                  {devPortalPage}
                </div>
              </div>

              <Footer />
            </>
            : // Admin Page
            <> 
              <AdHeader />
              <div className="layoutGrid ad">
                <AdSideMenu />

                <div className="layoutContents ad">
                  {devPortalPage}
                </div>
              </div>
            </>
        }
      </> 
    )
  } else {
    return (
      <div className="loadingBox">
        {/* Loading... */}
      </div>
    )
  }
}

export default App;